import { render } from "./TheRouter.vue?vue&type=template&id=01c76553&scoped=true"
import script from "./TheRouter.vue?vue&type=script&lang=js"
export * from "./TheRouter.vue?vue&type=script&lang=js"

import "./TheRouter.vue?vue&type=style&index=0&id=01c76553&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c76553"]])

export default __exports__